(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/result/result-sport.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/result/result-sport.js');

'use strict';

const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const Loader = svs.components.ReactLoader.Loader;
const _svs$ui = svs.ui,
  _svs$ui$ReactCard = _svs$ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody,
  _svs$ui$ReactForm = _svs$ui.ReactForm,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option;
const ResultChart = svs.grassroots.components.result.ResultChart;
const ErrorDialog = svs.grassroots.components.ErrorDialog;
const ResultSport = _ref => {
  let cms = _ref.cms,
    currentSport = _ref.currentSport,
    setCurrentSport = _ref.setCurrentSport,
    sports = _ref.sports;
  const response = grassrootsQueryApi.useFetchResultSportQuery(currentSport.name);
  const getChartDataSport = () => ({
    categories: response.data.records.map(year => year.year),
    values: response.data.records.map(year => year.amount)
  });
  if (response.isError) {
    return React.createElement(ErrorDialog, null);
  }
  if (response.isLoading) {
    return React.createElement(Loader, {
      size: 300
    });
  }
  return React.createElement("div", null, React.createElement(Select, {
    id: "valj-sport",
    label: cms.sportResult.dropdownSport,
    onChange: setCurrentSport,
    v2: true,
    value: currentSport.name
  }, sports.map(sport => React.createElement(Option, {
    key: sport.id,
    name: sport,
    value: sport.name
  }, sport.name))), response.isLoading && React.createElement(Loader, {
    size: 300
  }), response.isSuccess && React.createElement("div", null, React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "margin-top-1"
  }, React.createElement(CardBody, null, React.createElement(ResultChart, {
    data: getChartDataSport(),
    title: "".concat(cms.sportResult.payoutHeading, " ").concat(currentSport.name.toLowerCase())
  })))));
};
svs.grassroots.components.result.ResultSport = ResultSport;

 })(window);